import { RadioGroupProps } from '@material-ui/core/RadioGroup';
import { useField } from 'formik';
import React, { FunctionComponent } from 'react';
import { withFormElementErrorWrapper } from '../FormElementWrapper/FormElementWrapper';
import { RadioGroup } from 'ui-components';

const FormikRadioGroup: FunctionComponent<Omit<RadioGroupProps, 'name'> & {
  name: string;
}> = ({ children, onChange, ...props}) => {

  const [field] = useField(props.name);

  const radioGroupOnChange = (event: React.ChangeEvent<HTMLInputElement>, value: string): void => {
    if (onChange) {
      onChange(event, value);
    } else {
      field.onChange({ target: { id: field.name, value: event.target.value } });
    }
  };

  return (
      <RadioGroup data-testid="radio-group"
                  {...field}
                  onChange={radioGroupOnChange}
                  {...props}>
        {children}
      </RadioGroup>
  );
};

export default withFormElementErrorWrapper(FormikRadioGroup);
